module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch01"
    }
  }, [_vm._v("Getting started")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The basics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pests and diseases")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Growing vegetables")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Growing fruit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greenhouses and polythene tunnels")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suppliers")])]), _vm._v(" "), _c('figure', {
    staticClass: "imagey"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0005-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0